module.exports = __webpack_public_path__ + "static/media/profileExample.aeaa6601.png";